import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Stack } from 'react-bootstrap';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import ClaimerSubmissionStatus from './ClaimerSubmissionStatus';
import ClaimerMessages from './ClaimerMessages';
import NoHmrc from './NoHmrc';
import aifSubmissionsService from '../../services/claim/aif_submissions.service';
import claimerMessagesService from '../../services/claim/claimer_messages.service';
import claimService from '@rd-web-markets/shared/dist/services/claim/claim.service';
import DataToSendToClaimer from './data_preview/DataToSendToClaimer';
const HmrcSubmission = _ref => {
  let {
    company,
    claim: propClaim,
    subsidiaryClaim
  } = _ref;
  const [aifClaim, setAifClaim] = useState(null);
  const [claim, setClaim, fetchClaim] = claimService.useFetch({
    claimId: propClaim.id,
    fetchImmediately: true
  });
  useEffect(() => {
    if (company.requires_separate_aif_submission) {
      setAifClaim(subsidiaryClaim);
    } else {
      setAifClaim(claim);
    }
  }, [claim, company.requires_separate_aif_submission, subsidiaryClaim]);
  const {
    t
  } = useTranslation();
  const [submissionStatusLoading, setSubmissionStatusLoading] = useState(true);
  const [dataToSendToClaimerLoading, setDataToSendToClaimerLoading] = useState(true);
  const [aifReportCreationString, setAifReportCreationIdString] = useState(aifClaim?.claimer_aif_report_creation_id);
  const aif_claim_type = company.requires_separate_aif_submission ? 'subsidiary_claim' : 'claim';
  const {
    submissionStatuses,
    setSubmissionStatuses,
    currentSubmissionStatus,
    setCurrentSubmissionStatus,
    fetchStatuses
  } = aifSubmissionsService.useFetchAll({
    claim: aifClaim,
    setLoading: setSubmissionStatusLoading,
    aif_claim_type
  });
  const {
    aifReportData,
    setAifReportData,
    fetchAifReportData
  } = aifSubmissionsService.useFetchAifReportData({
    claim: aifClaim,
    setLoading: setDataToSendToClaimerLoading,
    aif_claim_type
  });
  const [claimerMessages, setClaimerMessages] = claimerMessagesService.useFetchAll({
    claimId: aifClaim?.id,
    aif_claim_type
  });
  const noSubmissionStarted = !aifClaim?.claimer_aif_report_creation_id;
  const submissionIsDoneOrCancelled = ['submitted', 'cancelled', 'error', undefined].includes(currentSubmissionStatus?.status);
  const canSubmitAif = noSubmissionStarted || submissionIsDoneOrCancelled;
  const onAifSubmisison = useCallback(async () => {
    await fetchClaim();
    await fetchStatuses();
    setCurrentSubmissionStatus(currentSubmissionStatus => ({
      ...currentSubmissionStatus,
      status: 'awaiting_approval'
    }));
  }, [fetchClaim, fetchStatuses, setCurrentSubmissionStatus]);
  if (!aifClaim) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (submissionStatusLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-center my-4"
    }, /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement("div", {
      className: "mt-2"
    }, t('loading_claim_aif_status')));
  }
  const hmrcConfirmationPdfLink = aifClaim?.hmrc_confirmation_pdf ? /*#__PURE__*/React.createElement("a", {
    href: aifClaim?.hmrc_confirmation_pdf.url,
    target: "_blank",
    rel: "noreferrer"
  }, aifClaim?.hmrc_confirmation_pdf.filename) : /*#__PURE__*/React.createElement("p", null, t('no_file_has_been_uploaded'));
  return /*#__PURE__*/React.createElement("div", {
    className: "border rounded p-3 bg-white"
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('aif_submission_status')), /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement(ClaimerSubmissionStatus, {
    claim: aifClaim,
    status: currentSubmissionStatus?.status
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('hmrc_confirmation_id')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, currentSubmissionStatus?.status === 'submitted' && aifClaim.claimer_aif_hmrc_confirmation_id ? aifClaim.claimer_aif_hmrc_confirmation_id : t('aif_not_yet_confirmed_by_hmrc'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('hmrc_confirmation_document')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, currentSubmissionStatus?.status === 'submitted' && aifClaim.hmrc_confirmation_pdf?.url ? hmrcConfirmationPdfLink : t('hmrc_confirmation_document_not_received_yet'))), aifReportCreationString && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('claimer_creation_id')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, aifReportCreationString)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('claimer_messages')), /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement(ClaimerMessages, {
    claimerMessages: claimerMessages
  })))), canSubmitAif && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(NoHmrc, {
    loading: submissionStatusLoading,
    setLoading: setSubmissionStatusLoading,
    claimId: aifClaim?.id,
    isFisrstSubmission: noSubmissionStarted,
    setAifReportCreationIdString: setAifReportCreationIdString,
    onAifSubmission: onAifSubmisison,
    aif_claim_type: aif_claim_type,
    disabled: aifReportData?.errors?.length > 0
  }))), /*#__PURE__*/React.createElement("div", null, dataToSendToClaimerLoading && /*#__PURE__*/React.createElement(Loader, null), !dataToSendToClaimerLoading && /*#__PURE__*/React.createElement(DataToSendToClaimer, {
    aifReportData: aifReportData
  }))));
};
export default HmrcSubmission;